<div class="container_width">
  <div class="w-full flex flex-column gap-3">
    <div class="w-full flex align-items-center gap-2 justify-content-between">
      <h1 class="text-left font-bold text-4xl">Scheduled Meetings</h1>
      <!-- <a class="w-auto px-3 py-2 border-round-lg inline-flex align-items-center gap-2 text-center recent_mettings">
        <i class="pi pi-history"></i>
        <p class="hidden sm:inline-block">Recent Meetings</p>
      </a> -->
    </div>
    <app-meeting-filters (onSearch)="searchMeetings($event)" [isSearching]="isSearching"></app-meeting-filters>
    <div class="w-full flex flex-column gap-2">
      <h2 class="w-full block text-left font-medium text-xl">Meetings</h2>
      <p-table *ngIf="meetings && meetings.length > 0; else noRecordsFound" [value]="meetings" [lazyLoadOnInit]="false"
        [paginator]="meetings.length!=total" [rows]="rowSize" [loading]="isSearching" [totalRecords]="total"
        [first]="first" [lazy]="true" (onLazyLoad)="onLazyLoad($event)" [rowsPerPageOptions]="[10, 20, 30]"
        [showPageLinks]="true" styleClass="p-datatable-gridlines tableCon" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Meeting with</th>
            <th>Date</th>
            <th>Meeting Time</th>
            <th>Meeting Note</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-meeting>
          <tr style="background-color: #FFDEDE;">
            <td>
              <a [routerLink]="['/mentor-portal','app-applicant-profile', meeting.id]" target="_blank" routerLinkActive="router-link-active"  class="w-auto cursor-pointer inline-flex align-items-center gap-2 hover:text-blue-700">
                <!-- <div class="w-2rem h-2rem border-circle overflow-hidden">
                  <img src="../../../assets/images/muskaan.jpg" alt="" class="w-2rem h-2rem" style="object-fit: cover;">
                </div> -->
                <b class="text-left text-base font-medium" style="letter-spacing: -.5px;">{{meeting.firstName+' '+
                  meeting.lastName}}</b>
              </a>
            </td>
            <td>{{getLocalDate(meeting.meetingDateTime)}}</td>
            <td>{{getLocalTime(meeting.meetingDateTime)}}</td>
            <td>{{meeting.meetingNotes}}</td>
            <td>
              <div *ngIf="meeting.status!=2" class="w-auto flex justify-content-center align-items-center gap-1">
                <p-button label="Join" icon="pi pi-check" styleClass="join"
                (onClick)="openCalendlyURI(meeting.joiningUrl)" />
                <p-button label="Cancel" icon="pi pi-times" styleClass="cancel"
                (onClick)="openCalendlyURI(meeting.cancelUrl)" />
                <p-button label="Reschedule" icon="pi pi-undo" styleClass="resch"
                (onClick)="openCalendlyURI(meeting.rescheduledUrl)" />
                <p-button label="Add Note" icon="pi pi-plus-circle" styleClass="join"
                (onClick)="getMeetingNotes(meeting.scheduledMeetingId)" />
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <ng-template #noRecordsFound>
        <div class="w-full flex flex-column align-items-center py-4 gap-5">
          <div class="w-full flex align-items-center justify-content-center">
            <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
          </div>
          <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<p-dialog
    header="Header"
    [(visible)]="visible"
    [modal]="true"
    [style]="{ width: '35rem' }">
        <ng-template pTemplate="header">
            <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class="font-bold white-space-nowrap">
                    Meeting Notes:
                </span>
            </div>
        </ng-template>
        <textarea class="w-full p-inputtext" rows="5" [(ngModel)]="meetingNoteText" placeholder="Enter your notes here..."></textarea>
        
        <ng-template pTemplate="footer">
            <p-button [disabled]="!meetingNoteText"
                label="Delete"
                severity="secondary"
                (onClick)="deleteMeetingNotes(currentMeetingId!)" styleClass="cancelBtn"/>
            <p-button [disabled]="!meetingNoteText"
                label="Update"
                severity="primary"
                styleClass="confirmBtn"
                (onClick)="addMeetingNotes()"/>
        </ng-template>
  </p-dialog>
